import bilateralContractApi from '@/api/purchaseSalesCenter/bilateralContract.js';
import { filterEmpty } from '@/common/js/util';
export default {
  methods: {
    // 表格上面的按钮
    chooseClick(type) {
      try {
        this[type]();
      } catch (error) {
        console.log(error);
        this.$message({
          showClose: true,
          type: 'error',
          message: '该方法未提供',
        });
      }
      console.log(type);
    },
    // 创建新单
    createOrder() {
      let path = {
        path: '/saleManage/bilateralContractCreate',
        name: 'bilateralContractCreate',
        meta: {
          keepAlive: false,
          title: '双边合同创建新单',
        },
        query: {
          status: 'create',
        },
      };
      this.$router.push(path);
    },
    // 复制
    copy() {
      if (this.selectedItems.length != 1) {
        this.$message.error('只能选择一行操作');
        return;
      }
      // 判断不是已经生效的不能复制
      const row = this.selectedItems[0];
      if (row.contractStatus != 'ZT03') {
        this.$message.error('当前合同不是已生效的状态,不能复制');
        return;
      }
      const path = {
        path: '/saleManage/bilateralContractDetail',
        name: 'bilateralContractDetail',
        meta: {
          keepAlive: false,
          title: '双边合同详情',
        },
        query: {
          status: 'copy',
          copyFlag: '0',
          contractNo: row.contractNo,
        },
      };
      this.$router.push(path);
    },
    // 删除
    async delete() {
      if (this.selectedItems.length == 0) {
        this.$message.error('请选择行操作');
        return;
      }
      const receiptStatusList = this.selectedItems.map((item) => item.contractStatus);
      if (
        !receiptStatusList.every((item) => item == 'ZT06') &&
        !receiptStatusList.every((item) => item == 'ZT05')
      ) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '请选择已保存或已驳回的数据!',
        });
        return;
      }
      this.$confirmAction()
        .then(() => {
          const ids = this.selectedItems.map((item) => item.id);
          const contractNos = this.selectedItems.map((item) => item.contractNo);
          this.loading.startLoading();
          this.$axios
            .post(bilateralContractApi.BATCH_DELETE_ORDER_API, {
              ids,
              contractNos,
              oaId: this.userInfo.oaId,
            })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('confirm.deleteCancelled'),
          });
        });
    },
    // 导出
    export() {
      const tableColumn = this.$refs.siruiTable.getTableColumn();
      const showColumns = [];
      tableColumn.visibleColumn.forEach((item) => {
        if (item.property) {
          showColumns.push({ prop: item.property, label: item.title });
        }
      });
      showColumns.unshift({ prop: 'rowNo', label: '序号' });
      const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
      //如果当前页和历史页没有记录 ，则看搜索区域
      if (this.selectedItems.length == 0 && selectedList.length == 0) {
        this.$message({
          showClose: true,
          message: '请至少选择一条数据进行导出',
          type: 'error',
        });
        return;
      }
      const query = { ...this.queryData };
      delete query.pageNum;
      delete query.pageSize;
      const params = filterEmpty(query);
      params.dataGroup = 'sb';
      params.idsExport = [];
      if (selectedList.length > 0) {
        selectedList.map((item) => {
          params.idsExport.push(item.id);
        });
      }
      if (this.selectedItems.length > 0) {
        this.selectedItems.map((item) => {
          params.idsExport.push(item.id);
        });
      }
      // 导出字段
      params.columns = JSON.stringify(showColumns);
      //默认 制单日期倒叙
      params.orderByDesc = this.sortParams;

      this.loading.startLoading();
      this.$axios.post(bilateralContractApi.EXPORT_EXCEL, params).then((res) => {
        this.loading.endLoading();
        if (res.data.code === 0) {
          window.location.href = res.data.data;
        } else {
          this.$alert(res.data.msg);
        }
      });
    },
    // 提交审批
    submit() {
      if (this.selectedItems.length == 0) {
        this.$message.error('请选择行操作');
        return;
      }
      const contractStatusList = this.selectedItems.map((item) => item.contractStatus);
      console.log(contractStatusList, '===>');
      if (contractStatusList.some((item) => !['ZT06', 'ZT05', 'ZT061', 'ZT051'].includes(item))) {
        this.$message.error('选择的合同状态不正确');
        return;
      }
      this.$confirmAction('提示', '你确定要提交审批')
        .then(() => {
          const ids = this.selectedItems.map((item) => item.id);
          const contractNos = this.selectedItems.map((item) => item.contractNo);
          this.loading.startLoading();
          this.$axios
            .post(bilateralContractApi.SUBMIT_BATCH, { ids, contractNos, oaId: this.userInfo.oaId })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.cancel(false);
              } else {
                this.$alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('confirm.deleteCancelled'),
          });
        });
    },
    // 创建提单
    async createBill() {
      if (this.selectedItems.length != 1) {
        this.$message.error('请选择一行操作');
        return;
      }
      if (this.selectedItems[0].contractStatus != 'ZT03') {
        this.$message({
          showClose: true,
          message: '请选择一条已生效的合同进行创建提单',
          type: 'error',
        });
        return;
      }
      // 判断如果不是销售的不能提单
      if (this.selectedItems[0].contractCategory != 'sales') {
        this.$message.error('不能创建提单');
        return;
      }
      this.loading.startLoading();
      const { data } = await this.$axios.post(bilateralContractApi.CHECK_LADING_QUANTITY, {
        contractNo: this.selectedItems[0].contractNo,
      });
      console.log(data, '销售提单');
      this.loading.endLoading();
      if (0 == data.code) {
        //跳转到销售提单页面
        let path = {
          path: '/salePurchase/materialSalesLadingbillAdd',
          name: 'materialSalesLadingbillAdd',
          meta: {
            keepAlive: false,
            title: '销售提单创建',
          },
          query: {
            contractNo: this.selectedItems[0].contractNo,
            type: 'bilateralContract',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      } else {
        this.$alert(data.msg);
      }
    },
    // 删除申请
    async deleteApply() {
      if (this.selectedItems.length == 0) {
        this.$message.error('请选择行操作');
        return;
      }
      const contractStatusList = this.selectedItems.map((item) => item.contractStatus);
      if (contractStatusList.some((item) => item !== 'ZT03')) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '请选择已生效的数据!',
        });
        return;
      }
      this.$confirmAction()
        .then(() => {
          const contractNo = this.selectedItems.map((item) => item.contractNo);
          this.loading.startLoading();
          this.$axios
            .post(`${bilateralContractApi.DELETE_APPROVE}`, {
              oaId: this.userInfo.oaId,
              contractNos: contractNo,
            })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('confirm.deleteCancelled'),
          });
        });
    },
    // 创建供应商发货指令
    async createSupplier() {
      const selectList = this.selectedItems;
      if (selectList.length != 1) {
        this.$message.error('请选择一条已生效合同');
        return;
      }
      if (selectList[0].contractStatus != 'ZT03') {
        this.$message.error('请选择一条已生效合同');
        return;
      }
      if (selectList[0].contractCategory != 'purchase') {
        this.$message.error('不能创建供应商发货指令');
        return;
      }
      if (await this.checkCreateSupplier()) {
        const rowData = this.selectedItems[0];
        const path = {
          path: '/wareHouse/addMateriaSupplierDeliveryOrder',
          name: 'addMateriaSupplierDeliveryOrder',
          meta: {
            keepAlive: false,
            title: '供货商发货指令维护',
          },
          query: {
            contractNo: rowData.contractNo,
            contractDetailNoList: rowData?.contractDetailNoList,
            businessContractUnitPrice: rowData?.businessContractUnitPrice,
            financeContractTaxAmount: rowData?.businessContractTaxAmount,
            financeContractPureAmount: rowData?.businessContractPureAmount,
            businessContractTotalAmount: rowData?.businessContractTotalAmount,
            productQuantity: rowData?.productQuantity,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      }
    },

    // 检查是否可以创建供货商发货指令
    async checkCreateSupplier() {
      if (this.selectedItems.length != 1) {
        this.$message.error('只能选择一行操作');
        return;
      }
      const { data } = await this.$axios.post(bilateralContractApi.CHECK_SHIPPING_INSTANCE, {
        contractNo: this.selectedItems[0].contractNo,
      });
      if (data.code == 0) {
        return true;
      } else {
        this.$message.error(data.msg);
        return false;
      }
    },
  },
};
